import { TimePicker } from '@/components'
import { Module } from '@/modules/companies/consts'
import { useTranslate } from '@ur-solutions/react-hooks'
import {
  SettingRow,
  SettingSwitch,
  SettingsSection,
} from './salary-settings-section'
import type { SalarySettingsTabProps } from './SalarySettingsFormView'

export const SalarySettingsPause: React.FC<SalarySettingsTabProps> = ({
  form,
  config,
}) => {
  const translations = useTranslate({
    paidPause: 'common.paid-pause',
    paidPauseThreshold: 'settings.paid-pause-threshold',
    countPaidPauseInTotalWork:
      'settings.timesheets.count-pause-as-part-of-total-work',
    calculateAddonsOnPaidPause:
      'settings.timesheets.calculate-addons-on-paid-pause',
    pauseSubtraction: 'settings.pause-subtraction',
    subtractPaidPauseAfterTotalWorkThreshold:
      'settings.subtract-paid-pause-after-total-work-threshold',
    pauseDuration: 'settings.pause-duration',
    pauseThreshold: 'settings.pause-threshold',
    availability: 'common.availability',
    countAvailabilityInTotalWork: 'settings.count-availability-in-total-work',
    countAvailabilityInOvertime: 'settings.count-availability-in-overtime',
    countAvailabilityExplanation: 'settings.count-availability-explanation',
  })
  const { formValues, updateForm } = form
  const isActivities = config.name === Module.ACTIVITIES
  const subtractsPause =
    !isActivities || formValues.subtractPaidPauseAfterTotalWorkThreshold

  return (
    <>
      {isActivities && (
        <SettingsSection title={translations.paidPause}>
          <SettingRow label={translations.paidPauseThreshold}>
            <TimePicker
              value={formValues.paidPauseThreshold}
              onChange={paidPauseThreshold =>
                updateForm({ paidPauseThreshold })
              }
            />
          </SettingRow>
          <SettingSwitch
            label={translations.countPaidPauseInTotalWork}
            checked={formValues.countPaidPauseInTotalWork}
            onChange={countPaidPauseInTotalWork =>
              updateForm({ countPaidPauseInTotalWork })
            }
          />
          <SettingSwitch
            label={translations.calculateAddonsOnPaidPause}
            checked={formValues.calculateAddonsOnPaidPause}
            onChange={calculateAddonsOnPaidPause =>
              updateForm({ calculateAddonsOnPaidPause })
            }
          />
        </SettingsSection>
      )}

      <SettingsSection title={translations.pauseSubtraction}>
        {isActivities && (
          <SettingSwitch
            label={translations.subtractPaidPauseAfterTotalWorkThreshold}
            checked={formValues.subtractPaidPauseAfterTotalWorkThreshold}
            onChange={subtractPaidPauseAfterTotalWorkThreshold =>
              updateForm({ subtractPaidPauseAfterTotalWorkThreshold })
            }
          />
        )}
        {subtractsPause && (
          <>
            <SettingRow label={translations.pauseDuration}>
              <TimePicker
                value={formValues.pauseDuration}
                onChange={pauseDuration => updateForm({ pauseDuration })}
              />
            </SettingRow>
            <SettingRow label={translations.pauseThreshold}>
              <TimePicker
                value={formValues.pauseThreshold}
                onChange={pauseThreshold => updateForm({ pauseThreshold })}
              />
            </SettingRow>
          </>
        )}
      </SettingsSection>

      {isActivities && (
        <SettingsSection title={translations.availability}>
          <SettingSwitch
            label={translations.countAvailabilityInTotalWork}
            checked={formValues.countAvailabilityInTotalWork}
            onChange={countAvailabilityInTotalWork =>
              updateForm({ countAvailabilityInTotalWork })
            }
          />
          <SettingSwitch
            label={translations.countAvailabilityInOvertime}
            description={translations.countAvailabilityExplanation}
            checked={
              formValues.countAvailabilityInTotalWork &&
              formValues.countAvailabilityInOvertime
            }
            disabled={!formValues.countAvailabilityInTotalWork}
            onChange={countAvailabilityInOvertime =>
              updateForm({ countAvailabilityInOvertime })
            }
          />
        </SettingsSection>
      )}
    </>
  )
}
